import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {useIntegrityRequirement} from '../hooks';

const RequirementGrid = (props: any) => {
  const loadRequi = useIntegrityRequirement(props.data.key);
  return (
    <IntegrityRoleGrid
      allowEdit={[Roles.AdminQA, Roles.AdminHSE]}
      dataSource={loadRequi}
      gridName={i18n2._('Requirement')}
      id={['iD_Course', 'iD_Sector', 'iD_Profile']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
    >
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" />
      <Column caption={i18n2._('#Perfil')} dataField="iD_Profile" />
      <Column caption={i18n2._('#Sector')} dataField="iD_Sector" />
      <Column
        caption={i18n2._('Fecha de Requerimiento')}
        dataField="req_Date"
      />
      <Column caption={i18n2._('Version')} dataField="version" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default RequirementGrid;
